import classnames from 'classnames/bind'
import { useRef } from 'react'
import { GlobalTextPreset } from '~/@types/text-preset'

import Slider from '@unlikelystudio/react-slider'

import InlineCta, { InlineCtaProps } from '~/components/UI/InlineCta'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type SideNavigationProps = {
  className?: string
  links?: InlineCtaProps[]
  sliceIndex?: number
}

function SideNavigation({ className, links, sliceIndex }: SideNavigationProps) {
  const customSliderRef = useRef()

  return (
    <div className={cx(css.SideNavigation, className)} ref={customSliderRef}>
      <div className={cx(css.container, css?.hideOnSmallScreen)}>
        {links?.map((link, index) => {
          const Tag = sliceIndex === 0 && link?.active ? 'h1' : 'span'
          return (
            <InlineCta
              key={`side_nav_item_${index}`}
              textPreset={GlobalTextPreset.Cta12Grotesk}
              className={cx(css.link, { active: link?.active })}
              lineProps={{ initialLineState: 'none' }}
              {...link}>
              <Tag>{link?.children}</Tag>
            </InlineCta>
          )
        })}
      </div>
      <Slider
        className={cx(css.slider, css?.hideOnLargeScreen)}
        snap
        customSliderRef={customSliderRef}>
        {links?.map((link, index) => (
          <InlineCta
            key={`side_nav_mobile_item_${index}`}
            textPreset={GlobalTextPreset.Cta12Grotesk}
            className={cx(css.link, { active: link?.active })}
            lineProps={{ initialLineState: 'none' }}
            {...link}
          />
        ))}
      </Slider>
    </div>
  )
}

SideNavigation.defaultProps = {}
export default SideNavigation
